module.exports = __webpack_public_path__ + "media/operational-monitoring_de_desktop.be02b8bd.webm";